import React, { FC } from 'react';
import { RecipeIngredientProps } from '../../atoms/RecipeIngredient';
import { IconProps } from '../../atoms/Icon';
import * as SC from './styled';
export type RecipeIngredientsProps = MinimalSeoBlock & {
  className?: string;
  title?: string;
  ingredients: RecipeIngredientProps[];
  nbOfPeople?: {
    text: string;
    icon: IconProps;
  };
};
const RecipeIngredients: FC<RecipeIngredientsProps> = ({
  className,
  htmlTag,
  title,
  htmlTitleTag,
  ingredients,
  nbOfPeople
}) => {
  const half = ingredients ? Math.ceil(ingredients.length / 2) : null;
  const leftItems = ingredients && half ? ingredients.slice(0, half) : null;
  const rightItems = ingredients && half ? ingredients.slice(half, ingredients.length) : null;
  return <SC.Container className={className} as={htmlTag}>
      <SC.Head>
        {title && <SC.Title as={htmlTitleTag}>{title}</SC.Title>}
        {nbOfPeople && <SC.NbOfPeople>
            <SC.PeopleIcon {...nbOfPeople.icon} />
            {nbOfPeople.text}
          </SC.NbOfPeople>}
      </SC.Head>
      <SC.Ingredients>
        {leftItems && <SC.IngredientsColumn>
            {leftItems?.map((ingredient, i) => <li key={i}>
                <SC.Ingredient {...ingredient} />
              </li>)}
          </SC.IngredientsColumn>}
        {rightItems && <SC.IngredientsColumn>
            {rightItems?.map((ingredient, i) => <li key={i}>
                <SC.Ingredient {...ingredient} />
              </li>)}
          </SC.IngredientsColumn>}
      </SC.Ingredients>
    </SC.Container>;
};
export default RecipeIngredients;